
import { parseJson, stringifyJson } from '../utilities/JsonUtils';
import { AccordionData } from '../commonComponent/AccordionsComponent';
import { FileSizeUnit, TextType } from './Constants';
import { getRootComponent } from '../utilities/ElementUtils';

export type SectionFilterValueMap = { [fieldName: string]: string[] };

export abstract class BaseType {
    Id: string;
    pageName: string;
    ENUTitle: string;
    ENUDescription: string;
    FRATitle: string;
    FRADescription: string;
    RecordType: string;
    Sequence: number;
    enuToolTip: string;
    fraToolTip: string;
    sharable: boolean;
    shareReferenceId: string;

    // visible: boolean = true;

    copyTo(copy: BaseType): void {
        copy.Id = this.Id;
        copy.ENUTitle = this.ENUTitle;
        copy.FRATitle = this.FRATitle;
        copy.Sequence = this.Sequence;
        copy.enuToolTip = this.enuToolTip;
        copy.fraToolTip = this.fraToolTip;
    }
    toInfoString() {
        return `Id:${this.Id}, Title:${this.ENUTitle}}`;
    }
}

/* ExtensionField Tags */
export abstract class BaseWithExtension extends BaseType {
    EGMSStyle: string;
    parent: BaseType = null;
}

export class FormSectionElements extends BaseWithExtension {
    Sequence: number;
    Datatype: string;
    Editable: string;
    Optional: string;
    Valid: boolean;
    Visible: boolean;
    parent: any; // Adjust to correct type if available
    findFieldByName: (fieldName: any) => any;
    findSectionByTitle: (sectionTitle: any) => any;
    findAnyFieldByName: (fieldName: any) => any;  // Regardless if it's hidden/visible
    formatField: (strInput: string, format: string, previousInput?: string | null | undefined) => string;
    StaticDropdownReference: string;
    LoadBindName: string;
    LoadBindNameFRA: string;
    // EntityType:string;
    LoadBindBase: string;    
    LoadBindBaseFRA: string;    
    isBXPaddress: boolean;  
    isPostCodeOptional: boolean;
    isStreetNumberOptional: boolean;
    freeTextStreetNumber?: boolean;
    isStreetNameOptional: boolean;
    isOtherOptional: boolean;
    isMunicipalityOptional: boolean;
    isProvinceOptional: boolean;
    hideCountry: boolean;
    hideRuralRoute: boolean;
    hidePOBox: boolean;
    hideStreetType: boolean;
    hideStreetDirection: boolean;
    hideUnitType?: boolean;
    hideTownship?: boolean;
    lockStreetFieldsAfterPopulate?: boolean;
    manualAddressChecked: boolean;
    Length: string;
    maxLength: number;
    isResizeNotAllowed: boolean;
    autoFormatPattern: string;
    RecordName: string;
    SubSectionId: string;
    TooltipENU: string;
    TooltipFRA: string;
    Type: string;
    day: string;
    month: string;
    year: string;
    MinDate: string;
    MinDateRelative: boolean;
    MinDateComparison: string;
    MinDateAmount: string;
    MinDateUnit: string;
    MaxDate: string;
    MaxDateRelative: boolean;
    MaxDateComparison: string;
    MaxDateAmount: string;
    MaxDateUnit: string;
    Value;
    Label; // used for dropdown components with custom values
    ENUValidateTitle: string;
    FRAValidateTitle: string;
    Language: string;
    converted: boolean;
    fieldValue: string; // input value holder
    FilterField;
    FilterValue;
    FilterFieldFRA;
    FilterValueFRA;
    FilterCompareMethod: string;
    filterSummaryListId?: string;
    filterSummaryListColumn?: string;
    filterSummaryListColumns?: string[];
    TargetFieldId?: string; // Legacy - single field
    TargetFieldIds?: string[]; // Legacy - multiple fields
    TargetFields?: Array<{fieldId: string; customLabel?: string}>;
    HideChangeLink?: boolean;
    ValidateCompareMethod: string;
    ValidateCompareField: string;
    DateCompareEnabled?: boolean | string;
    DateCompareWithField?: string;
    DateCompareOperator?: string;
    DateCompareErrorMessage?: string;
    DateCompareErrorMessageFRA?: string;
    ValueType: string;//when readonly, constant or calculated
    DecidingField1;
    CalculationMethod: string
    DecidingField2
    MeasurementUnit: string;
    HasSummaryRow: string;
    HasTotalColumn: string;
    FreezeColumn: string;
    HasGrandTotal: string;
    TableMenuRows?: any[];
    CMADashboard?: boolean;
    CMAQuestionComment?: string;
    CanadianAddress?: boolean;
    ListOfLOVValues: LOVValues[];
    ListOfExpectedValues: any[];
    ListOfReplacements: { [key: string]: any };
    accordions?: { expandAll: boolean; accordions: AccordionData[]; };
    accordionsFRA?: { expandAll: boolean; accordions: AccordionData[]; };
    summaryFromFlow?: boolean;
    UseClickedRowDataForSummaryList?: boolean;
    Api: string;
    ApiKeyKey?: string;
    ApiKeyValue?: string;
    apiResponse?:any;
    apiErrorRedirectPage?: number;
    ForRole: string;
    subSectionList: FormSubSections[];
    children?: FormSectionElements[];
    counterVisible: boolean;
    HasAddButton: string;
    DisplayTooltipValue: string;
    Script: string;
    EventScript: string; 
    PostScript: string;
    ScriptTriggerField: string;
    ScriptTriggerFieldValue: string;
    AffectedField: string;
    EnabledByField: string;
    EnabledByFieldValue: string;
    OnOff: string;
    MustHaveTrueValueInTable: string;
    Hint: string;
    HintFR: string;
    UpdateField: string;
    UpdateFieldFRA: string;
    syncAllBindingField: string;
    colWidth: string;
    AllowSorting: boolean;
    ButtonLabel: string;
    ButtonLabelFRA: string;
    filterDisplay: string;
    ErrorMessage: string='{0} is invalid.';
    ErrorMessageFRA: string='{0} est invalide.';
    callOutBoxType: string;
    callOutSize: string;
    callOutBoxTitle: string;
    callOutBoxTitleFRA: string;
    callOutBoxBody: string;
    callOutBoxBodyFRA: string;
    useRawCalloutBoxBody?: boolean;
    orderIdLabel: string;
    orderIdLabelFRA: string;
    orderDateLabel: string;
    orderDateLabelFRA: string;
    downloadPDFButtonLabel: string;
    downloadPDFButtonLabelFRA: string;
    downloadPDFURL: string;
    downloadPDFURLFRA: string;
    downloadPDFApiKeyKey?: string;
    downloadPDFApiKeyValue?: string;  
    confirmationTitle: string;
    confirmationTitleFRA: string;
    confirmationDescription: string;
    confirmationDescriptionFRA: string;
    showEmailField: string; // "hidden" | "optional" | "required"
    emailFieldTitle: string;
    emailFieldTitleFRA: string;
    emailFieldDescription: string;
    emailFieldDescriptionFRA: string;
    emailSendApi: string; // API endpoint for sending confirmation email
    sendWholeContainerAsPayload: boolean; //Submit all data stored in the ProgramContainer object as the request payload when invoking the service call.
    hintExpansionTitle: string;
    hintExpansionTitleFRA: string;
    hintExpansionContent: string;
    hintExpansionContentFRA: string;
    hintExpansionBelowElementLabel: boolean;
    hintExpanded: boolean;
    AttachmentList;
    Touched: boolean;
    RegularExpression: string;
    wrapCalloutbox: string;
    MessageTitle: string;
    MessageTitleFRA: string;
    MessageBody: string;
    MessageBodyFRA: string;
    ConfirmationEmail: string;
    AddEmptyItemToList: string;
    Checked: boolean;
    SelectionCode: string;
    ValueFRA: string;
    getAPI: string;
    richTextChecked: boolean;
    displayAsRichText: boolean;  // To display the content of the component as Rich-text.
    PCLookupUrl: string;
    AddressLookupUrl: string;
    MinValue: any;
    MaxValue: any;
    doNotAllowTrailingZeros?: boolean;
    Address: any;
    addressType?: AddressType;
    allowPartialAddress?: boolean;
    allowManualAddress?: boolean;
    clearAddressOnManualCheck?: boolean;
    allowUnknownAddress?: boolean;
    unknownAddressChecked?: boolean;
    autoSetCountryFromProvince?: boolean;
    showCountryField?: boolean;
    useTouchedForNonBxpErrors?: boolean;
    addressFieldLabels?: { [key: string]: string };
    addressFieldLabelsFRA?: { [key: string]: string };
    hideAddressFieldRequirementIndicators?: { [key: string]: boolean };
    manualAddressEntryLabel?: string;
    manualAddressEntryLabelFRA?: string;
    addressErrorMessages?: { [key: string]: string };
    addressErrorMessagesFRA?: { [key: string]: string };
    returnAdrressObject?: boolean;
    hideAddressDetails: boolean;
    hideUnitNumber?: boolean;
    suppressUnitOnAddressSearch?: boolean;
    hideStreetNumberSuffix: boolean;
    hideStreetNumberNameCheckbox: boolean;
    combineStreetFields?: boolean;
    commaAfterStreetNumber?: boolean;
    populateUnitInStreetNumber?: boolean;
    restrictManualAndNoStreet?: boolean;
    licensePlateType?: string;
    licensePlateRegex?: string;
    TextType?: TextType;
    informationalText: string;
    informationalTextFRA: string;
    mailingSameAsResidential: boolean;
    showMailingDetails: boolean;
    mask: boolean;
    Recaptcha?: { action: string; content?: {en?: string; fr?: string;}, handlerName?: string; api?: string; };
    SubmitButton?: SubmitButtonType;
    SearchFilter?: { enabled?: boolean; Script?: string; EventScript?: string; InitScript?: string; };
    displayInEditor:boolean;
    ClassName ;
    FileUpload?: { 
        UploadField?: UploadFieldProps, 
        AllowedForUploadFileTypeList?: UploadFileType[]; 
        PreviewFile?: boolean; 
        hasDescription?: boolean, 
        LegacyStyle?: boolean;
        UploadStyle?: 'default' | 'inline-error'; 
        UploadedFileDisplayStyle?: 'original' | 'legacy' | 'new'; 
        FileSizeLimit?: number; 
        FileSizeInTotal?: number; 
        SizeUnite?: FileSizeUnit;
        FileSizeExceedErrorENU?: string;
        FileSizeExceedErrorFRA?: string;
        hidePopup?: boolean;
        maxWrongAttemps?: number;
        indexAfterMaxAttempts?: number; 
        fileScanOnUpload?: boolean; 
        multipleFiles?: boolean; 
        maxFileCount?: number; 
        maxFileCountErrorMessage?: string; 
        isBXPCustomErrorMessage?: boolean; 
        allowDuplicateName?: boolean; 
        fileTypePrefix?: string; 
        fileTypePrefixFRA?: string; 
        previewButtonVerticalAlign?: boolean; 
        validateXML?:any;
        multiPart?: boolean;
    };
    ShowFileErrorDialog?: boolean;
    TableData?: {colMapping?: DataTableColumnMap[]; paginator?: Pagination; triggerPayload: any; };
    EmptyErrorMessage: string;
    EmptyErrorMessageFRA: string;
    IsEmpty:boolean;
    MaskInSummary: boolean;
    hideInSummary: boolean;
    input?: {triggerSubmitOnEnter?: boolean; submitCollect?: boolean; onlyNumbers?: boolean};
    InitScript: string;
    ReadOnly: boolean;
    Sort: boolean;
    LovAPI: string;
    StepperScript: string;
    FieldMustBeAtTop: boolean;
    ErrorContentValueFRA: string;
    ErrorContentValue: string;
    feedback?: { status?: string; code?: string; }
    inlineStyling: boolean;
    ValidateStep: string;
    SubmissionMethod: any;
    ErrorMessageRichText: string='{0} is invalid.';
    ErrorMessageRichTextFRA: string='{0} est invalide.';
    Columns: TableColumn[];
    FeedbackURL_CXP: string;
    FeedbackURL: string;
    FeedbackURLFRA: string;
    FeedbackURLFRA_CXP: string;
    feedbackLinkIsHyperlink?: boolean;
    isContinueFile?: boolean;
    KeyStrokeScript: any;
    LengthInPixel: string;
    Gap: string;
    indents?: number;
    Single: string;
    Horizontal: string;
    sectionGroupToDuplicate?: string; // specify which section to duplicate for button element action
    isDeleteButton?: boolean; // specify if the button is for delete action
    SubSectionToDuplicate?: string; // specify which subsection to duplicate for button element action
    Disabled: boolean; // used to disable the field
    Cards: Card[];
    CardColumnNumber: number;
    cardImageLayout: string; // "inline" (default) or "top"
    BypassCollect: boolean;
    NoLabel: boolean; // used to hide the label in the UI
    MarginBottom: string; // used to set the margin bottom for the field
    MarginTop:string;
    GroupContinuation: boolean; // used to collapse top spacing when element continues from previous element
    // Old indivisdual Popup related configurations. 
    PopupTitle: string;
    PopupTitleFRA: string;
    ShowPopup: boolean;
    PopupMessage: string;
    PopupMessageFRA: string;
    PopupCancelButtonText: string;
    PopupCancelButtonTextFRA: string;
    PopupSaveButtonText: string;
    PopupSaveButtonTextFRA: string;
    HidePopupCancelButton: boolean;
    // New Popup related configurations container.
    PopupDialogConfigs: PopupDialogConfigurations;

    ConfirmAPI?: string; // API to call when popup is confirmed in PagedSummaryList
    ConfirmAPIMethod?: string; // HTTP method for ConfirmAPI: 'post', 'put', 'delete' (default: 'delete')
    DateISOFormat: boolean;
    IsCancelButton?: boolean; // Treat as cancel/exit button that redirects after confirmation
    IsSaveDraftButton?: boolean; // Treat as save draft button for inline placement with Continue
    SaveDraftToDatabase?: boolean; // Save to session if not selected.
    SaveDraftToDatabaseSuccessMessageElement?: string; // LoadBindName of the message element to be visible.
    CancelRedirectUrl?: string;
    CancelRedirectUrlFRA?: string;
    keepUnmatchedInput: boolean;  // For SearchAutocompleteComponent
    touchedAddressFields: string[];

    // For OrderInfoBreakdownComponent in OrderConfirmationComponent
    showOrderInfoSection: boolean;

    //To enable Custom Rich Text Error Message in ErrorAlertsComponent 
    enableCustomRichTextErrorMessage?: boolean;

    //Display email field at the bottom & enable for logged-in users as well in OrderConfirmationComponent
    displayEmailFieldForAllUsersAtBottom?: boolean;

    //Enable Highlight field for error in AutoSearchComponent
    enableHighlightFieldError?: boolean;
    showErrorAboveLabel?: boolean;

    
    // For CheckPlateAndRenderImageComponent
    enableCheckPlate: boolean;  
    defaultPlateCharacters: string;
    buttonText: string;
    buttonTextFra: string;

    IsErrorFromAPI: boolean;
    BackUrl: string;
    BackUrlFRA: string;
    Centered: boolean;
    ButtonProps: ButtonConfig;
    InlineStyle: string;
    showOptionalLabel: boolean;
    excludedFromPayload: boolean;
    TableCaptionENU: string;
    TableCaptionFRA: string;
    TableEmptyMessage: string;
    TableEmptyMessageFRA: string;
    CustomButtonText: string;
    CustomButtonTextFRA: string;
    InvisibleByDefault: boolean;
    FadeOut: boolean;
    FadeOutSeconds: number;
    fadeOutTime?: number;
    ToDisplayWhenEmpty: string;
    ToDisplayWhenEmptyFRA: string;
    DateDisplayFormat: string;
    IsDirty: boolean;
    AlwaysDisplayCity: boolean;
    AlwaysDisplayProvince: boolean;
    MultipleSelectionsProps: MultipleSelectionsProperties;

    // PagedSummaryList properties
    // SummaryList: https://designsystem.ontario.ca/components/preview/summary-list.html
    // Table: https://designsystem.ontario.ca/components/detail/tables.html
    SummaryType: 'SummaryList' | 'Table';
    PageSize?: number;
    ShowDownloadButton: boolean;
    DownloadTitle: string;
    ShowTotalCount: boolean;
    ShowHeaderLink: boolean;
    ShowLinkWhenEmpty: boolean;
    HeaderLinkText: string;
    HeaderLinkTextFra: string
    HeaderLinkStepperScript: string;
    ShowItemLink: boolean;
    ItemLinkText: string;
    ItemLinkTextFRA: string;
    ShowBottomButton: boolean;
    BottomButtonHasRecaptcha: boolean;
    BottomButtonClassName: string;
    BottomButtonLabel: string;
    BottomButtonLabelFRA: string;
    BottomButtonStepperScript: string;
    ShowPagination: boolean;
    TotalCountPath: string;
    IsLastPath: string;
    DataPath: string;
    ClientSidePagination: boolean;
    RefreshOnLoad: boolean;
    LazyLoading: boolean;
    noMyTransactionsLink: boolean;
    disableConfirmationUrlRewrite:Boolean; // dont update order confirmation URL if set to true

    // Clickable column properties (for PagedSummaryList columns)
    IsClickable: boolean;
    AccessibilityLabel: string; 
    ClickUrl: string;
    ClickNextStep: number;
    ClickApiResponseField: string;
    StoreClickedRowData: boolean;

    maxDisplayLength?: number;

    popupError?: boolean; 

    DynamicAccordionFormConfig?: {
        titleField: string;
        entriesField: string;
        notDisplayHeader: boolean;
        notDisplayTitle: boolean;
        recordFilteringScript: string;
        formFields: Array<{
            bindName: string;
            label: string;
            labelFRA?: string;
            type: 'Text' | 'Number' | 'Date' | 'Dropdown' | 'ReadOnly';
            required?: boolean;
            editable?: boolean;
        }>;
    };

    TileSelection?: {
        apiUrl: string;
        responseKey?: string;
        idField?: string;
        nameField?: string;
        autoSelectSingle?: boolean;
        redirectUrl?: string;
        nextSection?: number;
    };

    // Incident Report Confirmation properties
    ShowSubmittedTable: boolean;
    DynamicTitleEN: string;
    DynamicTitleFR: string;

    // Download component properties
    DownloadMaxFileSize: number;

    // OrderPriceBreakdown component configurations
    OrderBreakdownConfig: OrderBreakdownConfigurations;

    fieldSize: string;
    fieldHintSize: string;

    clone(): FormSectionElements {
        let copy: FormSectionElements = new FormSectionElements();

        super.copyTo(copy);

        copy.Datatype = this.Datatype;
        copy.Editable = this.Editable;
        copy.Value = this.Value;
        copy.ListOfLOVValues = this.ListOfLOVValues;

        // copy.labelVisible = this.labelVisible;
        // copy.valueAsLabel = this.valueAsLabel;
        copy.fieldValue = this.fieldValue;
        copy.DynamicAccordionFormConfig = this.DynamicAccordionFormConfig ? { ...this.DynamicAccordionFormConfig } : undefined;
        return copy;
    }

    clearValue(): FormSectionElements {
        let copy: FormSectionElements = new FormSectionElements();

        super.copyTo(copy);

        copy.Datatype = this.Datatype;
        copy.Editable = this.Editable;
        copy.Value = "";
        copy.ListOfLOVValues = this.ListOfLOVValues;

        // copy.labelVisible = this.labelVisible;
        // copy.valueAsLabel = this.valueAsLabel;
        copy.fieldValue = this.fieldValue;
        return copy;
    }
}

export class Card{
     CardTitle: string;
    CardTitleFRA: string;
    CardHyperlink: string;
    CardHyperlinkFRA: string;
    imageContent: string;
    bodyContent: string;
    CardbodyContent: string;
    CardbodyContentFRA: string;
    RedirectUrl: string;
    RedirectUrlFRA: string;
    Sequence: number;
    Script: string;
}

export class CMAScore {
    label: string;
    labelFRA: string;
    level: number;
    definition: string;
    definitionFRA: string;
    KPMGdefinition: string;
    KPMGdefinitionFRA: string;
    toolTip: string;
    toolTipFRA: string;
}

export class FormButtons {
    Label: string;
    Status: string;
    Api: string;
    ApiKeyKey?: string;
    ApiKeyValue?: string;
    Icon: string;
    Script: string;
    VisibleStatus: string;
    ForRole: string;
    BackButton: string;
}

export class CallOutBox {
    CalloutType: string;
    Title: string;
    BodyMsg: string;
    Status: string;
    Script: string;
    VisibleStatus: string;
}

export class FormSubSectionFilter {
    ListOfFormSectionElements: FormSectionElements[] = [];
    ListOfButtons: FormButtons[];
}

export class FormSubSections extends BaseWithExtension {
    SectionId: string;

    ListOfFormSectionElements: FormSectionElements[] = [];
    ListOfFormChildSection: FormSubSections[];
    RoleHasAddbutton: string;
    HasPopup: string;
    ButtonLabel: string;
    EntityType: string
    WithinTab: string;
    Api: string;
    ApiKeyKey?: string;
    ApiKeyValue?: string;
    Datasource: string;
    ListOfButtons: FormButtons[];
    ForRole: string;
    OrderBy: string;
    EditableStatus: string;
    OwnerEditableOnly: string;
    HasTotalColumn: string;
    parent;
    NoCardInSummary:boolean;
    displayInCard: boolean;
    CanBeDuplicate: boolean;
    IsDuplicate: boolean;
    SummarizeDuplicateSubsection: string;
    ReadOnlyElements: boolean;
    HideChangeLink?: boolean;
    // Repeatable:string;
    // FilterListOfFormSectionElements:  FormSectionElements[]=[];
    // FilterListOfFormSectionButtons:  FormButtons[]=[];
    ValidateStep?: string;
    SubmitButton? : {
        ValidateStep?: string;
        enableRecaptcha?: boolean;
        enablePanignation?: boolean;
    };
    Paging: string;
    Visible: boolean;
    FilterField;
    FilterValue;
    PreScript: string;
    PostScript: string;
    StepperScript: string;
    Image: string;
    displayInEditor: any;
    SubsectionBackground: string;
    RichTextChecked: boolean;
    srOnly: boolean;
    CustomizedSummaryTextElementStyle: string;
    ChangeLinkProps?: ChangeLinkProperties;
    KeepDuplicatesEditable?: boolean;
    clone(): FormSubSections {
        const root = getRootComponent(this);
        return parseJson(stringifyJson(this, root.CategoryId), root.CategoryId);
    }
}

/* Finding FormSections using ExtensionField1 */
export class FormSections extends BaseWithExtension {
    ListOfFormSubSections: FormSubSections[];
    ListOfButtons: FormButtons[];
    ForRole: string;
    ReferencedFormSectionID: string;
    EntityType: string;
    GetAPI: string;
    UpdateAPI: string;
    DeleteAPI: string;
    SkipPageViewTracking: boolean; // When true, this section will not be tracked in analytics if certain conditions are met (e.g., Terms of Use already accepted)
    Value;
    CustomizedReviewPage: boolean;
    ExcludeFromCustomizedSummary?: boolean;
    followSubSectionOrder: boolean;
    CustomizedStyle?: SummaryStyleType;  // Deprecated, it is replaced by customizedSummaryStyle in CustomizedSummaryProperties.
    FilterField: string[];
    FilterValue: SectionFilterValueMap;
    FilterValueFRA: SectionFilterValueMap;
    Visible: boolean;
    IsFrontPage: boolean;
    IsTerminationPage: boolean;
    parent: any;
    NotStep: boolean;
    PreScript: string;
    PostScript: string;
    IsTechErrorPage: boolean;
    stepTitle?: string;
    stepTitleFRA?: string; 
    // IsTerminalSection:boolean;
    NoTotalPages: boolean;
    NoStepIndicator: boolean;
    IsInfoPage: boolean;
    findFieldByName: (fieldName: any) => any;
    findSubsectionByTitle: (fieldName: any) => any;
    findSectionByTitle: (sectionTitle: any) => any;
    formatField: (strInput: string, format: string, previousInput?: string | null | undefined) => string;
    IsConfirmationPage: boolean;
    TitleInStepIndicator: boolean;
    setHideTitle?: Boolean;
    NextButtonLabel:string;
    NextButtonLabelFRA:string
    GetToken: string;
    BackButtonLabel: string;
    BackButtonLabelFRA: string;
    BackButtonURLFRA: string;
    BackButtonURL: string;
    BackButtonStepperScript: string;
 
    Dynamic: boolean;
    StepperScript: string;
    ContinueScript: string;
    apiResponse?: any;
    IncludingCancelButton: string;  // Deprecated, it is replaced by includingCancelButton in CustomizedSummaryProperties.
    CancelButtonScript: string;  // Deprecated, it is replaced by cancelButtonScript in CustomizedSummaryProperties.
    NoDefaultContinue: boolean;
    NotCountedInSteps: boolean;
    LoginBanner: boolean;
    HasLoginBanner?: boolean;
    LoginBannerWording?: string;
    LoginBannerWordingFRA?: string;
    Background: string;
    BackgroundFRA: string;
    BackButtonSignedInLabel: string;
    BackButtonSignedInLabelFRA: string;
    BackButtonSignInURLFRA: string;
    BackButtonSignInURL: string;
    BackButtonShowPopup?: boolean;
    BackButtonPopupTitle?: string;
    BackButtonPopupTitleFRA?: string;
    BackButtonPopupMessage?: string;
    BackButtonPopupMessageFRA?: string;
    BackButtonPopupStayLabel?: string;
    BackButtonPopupStayLabelFRA?: string;
    BackButtonPopupLeaveLabel?: string;
    BackButtonPopupLeaveLabelFRA?: string;
    displayInEditor: any;
    srOnly: boolean;
    // Stepper: FormSectionStepper;
    CustomizedSummaryProps?: CustomizedSummaryProperties;
    SectionReadonly: boolean;
    AdditionalIcon: string;
    NoBackButton: boolean;
    FeedbackBanner: boolean;
    duplicateGroupID?: string;
    duplicateGroupIndex?: number;
    orginalClone: FormSections;
    KeepContinueButtonLeft: boolean;
    DisplayMaskIconLeft?: boolean;
    HaveTopButton?: boolean;
    preservePreScriptTitle?: boolean;
}

export interface LabelConfig {
    key: string;
    label: string;
    labelFRA: string;
    urlFRA: string;
    url: string;
}

export class FormSectionStepper {
    stepTitle?: string;
    stepTitleFRA?: string;
    NotStep: boolean;
    NoStepIndicator: boolean;
    NoTotalPages: boolean;
    stepHome: boolean;
}

/**
 * Top level Form Template holder
 */
export class ProgramContainer {
    id: string;
    Name: string;
    NameFRA: string;
    CategoryId: string;
    ReportBackType: string;
    ReportBackName: string;
    AppTitle?: {en?: string; fr?: string;};
    Instructions: string;
    Declaration: string;
    ListOfFormSections: FormSections[];
    UpdateAPI: string;
    GetAPI: string;
    DeleteAPI: string;
    CreateAPI: string;
    emailAPI: string;
    downloadAPI: string;
    analyticsAPI: string;
    IntObjectName: string;
    InitialDataAPI?: string;
    APIBasePath: string;
    ApiKeyKey?: string;
    ApiKeyValue?: string;
    AuthRequired: string;
    Scopes?: string;
    UiAzureRegistration?: string;
    UiAzureTenantId?: string;
    displayForm: string;
    ForSiebel: string;
    pdfTemplate: string;
    pdfTemplateFRA: string;
    CustomSummaryHeader: string;
    CustomSummaryHeaderFRA: string;
    CustomApplicationHeader: string;
    CustomApplicationHeaderFRA: string
    isHorizontalLayout: boolean;
    HideApplicationName: boolean;
    useFeedbackUrlOnly?: boolean;
    HasSaveDraftButton: string;
    TopNavigation: boolean;
    CheckboxValueYN: string;
    UseProxy: string;
    UseAsterisks: string;
    HideOptionalText: string;
    ValidateSectionWhenBrowerForwardClicked?: boolean;
    ErrorBottom:boolean;
    NoReview: string;
    sendPageDataToGA: boolean;
    GATrackingID: string;
    GTMContainerId?: string;
    PageRedirection: PageRedirectionConfig;
    RedirectURL: string;
    RedirectURLFRA: string;
    HideFirstPageOnOntarioCaReferer: boolean;
    InitialClientScript: string;
    HeaderType: string;
    EnableExitPopup: string;
    ExitPopupTitle: string;
    ExitPopupMessage: string;
    ExitPopupStayButtonLabel: string;
    ExitPopupExitButtonLabel: string;
    FooterType: string;
    OntarioChat: boolean;
    NoClearButton: string;
    ClearFormAfterSubmit?: boolean;
    SocialMedia: any;
    // DisableJavascript:boolean;
    Profile: any;
    TimeoutPopup: boolean;
    TimeoutRedirectURL: string;
    TimeoutRedirectURLFRA: string;
    Deployed: boolean;
    createdById: string;
    IsComplete: boolean
    EnglishOnly: boolean;
    SubmitAsXML: boolean;
    HelpOption: boolean;
    HelpRichText: string;
    HelpRichTextFRA: string;
    HelpHeader: string;
    HelpHeaderFRA: string;
    HelpFooter: string;
    HelpFooterFRA: string;
    HeaderInitScript: string;
    InitialClientScriptAwait?: boolean;
    EmailCopy: boolean;
    EmailSender: string;
    EmailRecipients: string[];
    EmailSubject: string;
    EmailBody: string;
    InboxSubject: string;
    InboxBody: string;
    InboxSubjectFRA: string;
    InboxBodyFRA: string;
    DecryptPDFPassword: string;
    Coowners: any[];
    FeedbackURLFRA_CXP: string;
    FeedbackURL_CXP: string;
    FeedbackURLFRA: string;
    FeedbackURL: string;
    CMAOptionList?: CMAScore[];
    MinistryOptions: LOVValues[];
    SectorOptions: LOVValues[];
    ClusterOptions: LOVValues[];
    FunctionNameList: LOVValues[];
    Entity: any;
    CategoryNameList:LOVValues[];
    SubCategoryNameList: LOVValues[];
    OrganizationList: Organization[];
    CMATemplateList: CMATemplate[];
    Template: string;
    adminConfig?: AdminMessage;
    Creator:string;
    organizationName: string;
    HeaderConfig?: HeaderConfig;
    CustomHeaderMenuItems?: CustomHeaderMenuItem[];
    HeaderMenuConfig?: string;
    ForceApplicationHeaderMenu?: boolean;
    cmaComments?: CommentDetail[];
    orgId:number;
    formDataId?: number;
    userRole?: string;
    OriginURLFRA: string;
    OriginURL: string;
    Origin: string;
    OriginFRA: string;
    DynamicOriginWithPublicSecure: string;
    authToken: string;
    SubmitPreScript: string;
    SubmitPostScript: string;
    createdBy: string;
    itemId?: string;
    draftId?: string;
    ErrorDescriptionMap: ErrorDescriptionMapType[];
    MetaData: string;
    version: string;
    pageName: string;
    AutoSavedEnabled: boolean;
    saveLaterEnabled?: boolean;
    SaveInterval: string;
    skipDirtyCheck: boolean;
    resumeStepperIndex?: number;
    IsDirty: boolean;
    Response: any;
    ToSanitize: boolean;
    Hosted: any;
    BpsConfig?: BpsConfig;
    duplicatableGroups?: any;
    GlobalKeyValuePairs?: KeyValuePair[];
    ReturnToSummaryButton?: boolean;
    ReturnToSummaryButtonLabel?: string;
    ReturnToSummaryButtonLabelFRA?: string;
}

export interface KeyValuePair {
    key: string;
    value: string;
    description?: string;
    appName?: string;
}

export class ErrorDescriptionMapType{
    ErrorCode: string;
    Description: string;
    DescriptionFra: string;
}

export class Organization {
    organizationName: string;
    Address: string;
    Cluster: LOVValues;
    Ministry: LOVValues;
    sector: string;
    Lead1;
    Lead2;
    csPersonal;
    TechnologyOverview: string;
    SecurityOverview: string;
    Employees: number;
    ITDepartmentSize: number;
    SecurityDepartmentSize: number;
    CSEngagementLead;
    CSLead;
    EstimatedMaturityLevel: string;
    TargetMaturityLevel: string;
    AssessedMaturityLevel: string;
    Considerations: string;
    RemarksByEntity;
    RemarksByCS;
    Challenges: string;
    // Templates: CMATemplate[];
    Templates: string[];
    template:string;
    lead1;
    lead2;
    updatedById?: string;
    updatedDate?: string;
}

export class CMATemplate {
    Name: string;
    Functions: FunctionDetail[]
}

export class FunctionDetail{
   FunctionName: string
   CategoryNameList: string[];
   CategoryDetailList: CategoryDetail[];
}

export class CategoryDetail {
    CategoryName: string;
    SubcategoryNameList: string[];
    CommentsList?: CommentDetail[];
}

export class CommentDetail{
    Comments: string;
    MadeOn: string;
    MadeBy: string;
    Resolved?: boolean;
    role?: 'A' | 'C';
    id?: string;
    func?: string;
    category?: string;
}

/*LOVValues tags */
export class LOVValues {
    id: string;
    Sequence: number;
    code: string;
    FRA: string;
    description: string;
    FRADescription: string;
    FilterField;
    FilterValue;
    FilterFieldFRA;
    FilterValueFRA;
    hintExpansionTitle: string;
    hintExpansionTitleFRA: string;
    hintExpansionContent: string;
    hintExpansionContentFRA: string;
    hintExpanded: boolean;
    callOutBoxType: string;
    callOutBoxTitle: string;
    callOutBoxTitleFRA: string;
    callOutBoxBody: string;
    callOutBoxBodyFRA: string;
    useRawCalloutBoxBody?: boolean;
    subItems: SubItem[];
    richText: string;
    richTextFRA: string;
    name?: string;
    nameFrench?: string;
    Script: string;
    Visible:boolean;
    parent: FormSectionElements;
    convertToBoolean?: boolean;
}

export class SubItem {
    code: string;
    FRA: string;
}
export class AddressFieldSets {
    addressLine1: string;
    addressLine2: string;
    city: string;
    province: string;
    postalCode: string;
}

export interface FileType {
    mimeType: string;
    ext: string;
}

export interface UploadFileType {
    val: FileType[], 
    label: string,
}

export interface CustomizedSummaryProperties {
    customizedSummaryStyle?: SummaryStyleType;
    includingCancelButton?: string;
    cancelButtonScript?: string;
    changeLinkInSubsectionLevel?: boolean;
    changeLinkScript?: string;
    hideAllChangeLinks?: boolean;
    buttonTopGap?: string;
}

export interface ChangeLinkProperties {
    changeLinkLabel?: string;
    changeLinkLabelFRA?: string;
}

export interface MultipleSelectionsProperties {
    allowMultipleSelection: boolean;
    displayListSize?: string;
    maxNumberOfSelection?: string;
}

export interface OrderBreakdownConfigurations {
    productSectionTitle?: string;
    productSectionTitleFRA?: string;
    paymentSectionTitle?: string;
    paymentSectionTitleFRA?: string;
    paymentColumn1Header?: string;
    paymentColumn1HeaderFRA?: string;
    paymentColumn2Header?: string;
    paymentColumn2HeaderFRA?: string;
    showPlateImage?: boolean;
}

export interface PopupDialogConfigurations {
    ShowPopup: boolean;
    ModalDialog: boolean;
    PopupTitle: string;
    PopupTitleFRA: string;
    PopupMessageIcon: string;
    PopupMessage: string;
    PopupMessageFRA: string;
    PopupLeftButtonClassName: string;
    PopupLeftButtonText: string;
    PopupLeftButtonTextFRA: string;
    PopupRightButtonClassName: string;
    PopupRightButtonText: string;
    PopupRightButtonTextFRA: string;
    PopupCloseable: boolean;
}

export const ShowDebugInfo: boolean = true;

export type AddressType = 'Residential' | 'Mailing' | 'Business';

export type HtmlAttribute = {
    name: string;
    value: string;
}

export type ScriptSource = {
    location: 'Head' | 'BodyStart' | 'BodyEnd';
    source: string;
    type?: 'text/javascript' | 'module';
    attributes?: HtmlAttribute[];
    isAsync?: boolean;
    isDefer?: boolean;
}

export type TableColumn={
    returnIndex: number;
    className: string;
    header:string;
    columnType: string;
    JavaScript: string
}

export type SummaryStyleType = 'Button' | 'Link' | 'Table' | 'All' | 'Default';

export type API = {
    url: string;
    method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
    apiErrorRedirectPage?: string;
    apiSuccessRedirectPage?: string;
    responseCodeRoute?: { [key: string]: string } [];
}

export type APIKey = {
    key: string;
    value: string;
}

export type ButtonType = {
    title: string;
    api?: API;
    recaptha?: { action: string; content?: {en?: string; fr?: string;}, handlerName?: string; api?: string; };
    nextRoute?: number;
}

export type AdminMessage = {
    messageContent?: string;
    messageType?: string;
    messageContentFrench?: string;
    isActive?: boolean;
    fromTime?: string;
    toTime?: string;
    reason?: string;
};

export type AzureGroupType = {
    "@odata.type": string,
    classification?: string|null,
    createdDateTime?: string,
    creationOptions?: string[],
    deletedDateTime?: string|null,
    description?: string|null,
    displayName: string|null,
    expirationDateTime?: string|null,
    groupTypes?: string[],
    id: string,
    isAssignableToRole?: string|null,
    mail?: string|null,
    mailEnabled?: boolean,
    mailNickname?: string|null,
    membershipRule?: string|null,
    membershipRuleProcessingState?: string|null,
    onPremisesDomainName?: string|null,
    onPremisesLastSyncDateTime?: string|null,
    onPremisesNetBiosName?: string|null,
    onPremisesProvisioningErrors?: any[],
    onPremisesSamAccountName?: string|null,
    onPremisesSecurityIdentifier?: string|null,
    onPremisesSyncEnabled?: boolean,
    preferredDataLocation?: string|null,
    preferredLanguage?: string|null,
    proxyAddresses?: string[],
    renewedDateTime?: string,
    resourceBehaviorOptions?: any[],
    resourceProvisioningOptions?: any[],
    securityEnabled?: boolean,
    securityIdentifier?: string|null,
    theme?: string|null,
    serviceProvisioningErrors?: any[],
    transitiveMemberOf?: string[],
    uniqueName?: string|null,
    visibility?: string|null,
}

export type AzureUser = {
    businessPhones?: string[],
    displayName: string,
    givenName: string,
    jobTitle: string,
    mail: string,
    mobilePhone?: string,
    officeLocation?: string,
    preferredLanguage?: string,
    surname: string,
    userPrincipalName: string,
    id: string,
}

export type HeaderConfig = {
    notification?: boolean;
    comments?: boolean;
    category?: string;
    func?: string;
}

export type CustomHeaderMenuItem = {
    TitleEN?: string;
    TitleFRA?: string;
    LinkEN?: string;
    LinkFRA?: string;
    StepperScript?: string;
};

export type UploadFieldProps = {
    title?: {
        en?: string;
        fr?: string;
    }, 
    label?: {
        en?: string;
        fr?: string;
    },
}

export type SubmitButtonType = {
    api?: string;
    apiKeyKey?: string;
    apiKeyValue?: string;
    SubmissionMethod?: string;
    apiErrorRedirectPage?: number;
    apiSuccessRedirectPage?: RedirectSection[];
    responseDataName?: string;
    responseType?: string;
    ValidateStep?: string;
    enableRecaptcha?: boolean;
    recaptchaAction?: string;
    enablePanignation?: boolean;
    maxApiAttempts?: number;
    sendMetadataOnly?: boolean;
}

export type RedirectSection = {statusCode: string; redirectPage: number, title: string};

export type Pagination = {
    page: number;
    pageSize: number;
    total: number;
    sort?: { sortBy: string; sortOrder: 'asc' | 'desc'; }[];
}

export type DataTableColumnMap = {
    dataKey: string, 
    columnName: string, 
    columnType: "col" | "template"
}

export type PageRedirectionConfig = {
    shouldHandle?: boolean;
    api?: string;
    apiKeyKey?: string;
    apiKeyValue?: string;
    SubmissionMethod?: string;
    apiErrorRedirectPage?: number;
    apiSuccessRedirectPage?: RedirectSection[];
    responseDataName?: string;
    maxApiAttempts?: number;
}

export interface BpsConfig {
    domain: string;
    clientId: string;
    tokenEndpoint: string;
    refreshEndpoint?: string;
    userInfoEndpoint?: string;
    logoutEndpoint?: string;
}

export interface ButtonConfig {
    buttonPosition: 'left' | 'center' | 'right';
}
